import { RenderAnalysisSummaryItemProps } from "@models/platform-analysis/entities/steps/summary";
import { FeeCalculatorPortfolioLevel } from "@models/platform-analysis/enums/fee/portfolioLevel";
import { RootState } from "@redux/store";
import { memo } from "react";
import { SummaryPortfolioCompositionContainer } from "./container";

export const SummaryPortfolioComposition = memo(
  ({
    name,
    userType,
    portfolioLevel,
    disabled: sectionDisabled,
  }: RenderAnalysisSummaryItemProps) => {
    if (portfolioLevel !== FeeCalculatorPortfolioLevel.Family) return <></>;

    return (
      <SummaryPortfolioCompositionContainer
        title={name?.[userType]}
        disabled={sectionDisabled}
        getHiddenIndexesMapFunc={(state: RootState) =>
          state.platformAnalysis?.internal?.feeAnalysis?.hiddenIdsIndexMap
        }
      />
    );
  },
);
